import { render } from "./ActionsCard.vue?vue&type=template&id=5fb7e6a0&scoped=true"
import script from "./ActionsCard.vue?vue&type=script&lang=js"
export * from "./ActionsCard.vue?vue&type=script&lang=js"

import "./ActionsCard.vue?vue&type=style&index=0&id=5fb7e6a0&scoped=true&lang=css"

import exportComponent from "/home/nodeapps/vitamins/defensie/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb7e6a0"]])

export default __exports__